import React from 'react'
import Table, {
  TableBody,
  TableData,
  TableHeader,
  TableHeaderItem,
  TableRow,
} from 'components/Table'
import { useTranslation } from 'react-i18next'
import './BundleSchedulesTable.scss'
import { DATE_FORMAT } from '../../../../constant'
import DateUtils from '../../../../utils/date'
import { BundleScheduleModel } from '../../../../api/bundle/models/bundle-schedule.model'
import Button, { ButtonTheme } from '../../../../components/Form/Button'

const BundleSchedulesTable: React.FC<{
  data: BundleScheduleModel[]
  releaseScheduleClick: (schedule: BundleScheduleModel) => void
}> = ({ data, releaseScheduleClick }) => {
  const { t } = useTranslation()

  const releaseAvailable = (schedule: BundleScheduleModel | undefined) => {
    if (!schedule) {
      return false
    }

    return schedule.status === 'unassigned'
  }

  if (!data.length) {
    return (
      <div className='BundleSchedulesTable__no-data'>
        <p>{t('bundle.noData')}</p>
      </div>
    )
  }

  return (
    <div className='BundleSchedulesTable__table'>
      <Table className='CommonTable'>
        <TableHeader sticky>
          <>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.scheduleDetails.status')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.scheduleDetails.audience')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.scheduleDetails.campaign')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.scheduleDetails.startDate')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.scheduleDetails.endDate')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.scheduleDetails.consumedAt')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.scheduleDetails.freedAt')}
            </TableHeaderItem>
            <TableHeaderItem className='CommonTable__header-item'>
              {t<string>('bundle.scheduleDetails.actions')}
            </TableHeaderItem>
          </>
        </TableHeader>

        <TableBody>
          {data.map((schedule, i: number) => (
            <TableRow
              key={i}
              className='CommonTable__data-row BundleSchedulesTable__row'
            >
              <>
                <TableData
                  key={`${i}-status`}
                  className='CommonTable__data-item BundleSchedulesTable__status-row'
                >
                  <p>{t<string>(`bundle.scheduleStatus.${schedule.status}`)}</p>
                </TableData>
                <TableData
                  key={`${i}-audience`}
                  className='CommonTable__data-item'
                >
                  <p>{schedule.audience ?? '-'}</p>
                </TableData>
                <TableData
                  key={`${i}-campaign`}
                  className='CommonTable__data-item'
                >
                  <p>{schedule.campaign?.name ?? '-'}</p>
                </TableData>
                <TableData
                  key={`${i}-startDate`}
                  className='CommonTable__data-item'
                >
                  <p>{DateUtils.parseAndFormat(schedule.startDate, DATE_FORMAT)}</p>
                </TableData>
                <TableData
                  key={`${i}-endDate`}
                  className='CommonTable__data-item'
                >
                  <p>{DateUtils.parseAndFormat(schedule.endDate, DATE_FORMAT)}</p>
                </TableData>
                <TableData
                  key={`${i}-consumedAt`}
                  className='CommonTable__data-item'
                >
                  <p>
                    {schedule.consumedAt
                      ? DateUtils.parseAndFormat(schedule.consumedAt, DATE_FORMAT)
                      : '-'}
                  </p>
                </TableData>
                <TableData
                  key={`${i}-freedAt`}
                  className='CommonTable__data-item'
                >
                  <p>
                    {schedule.freedAt
                      ? DateUtils.parseAndFormat(schedule.freedAt, DATE_FORMAT)
                      : '-'}
                  </p>
                </TableData>
                <TableData
                  key={`${i}-actions`}
                  className='CommonTable__data-item'
                >
                  <Button
                    theme={ButtonTheme.BLUE}
                    onClick={() => releaseScheduleClick(schedule)}
                    disabled={!releaseAvailable(schedule)}
                  >
                    {t('bundle.release')}
                  </Button>
                </TableData>
              </>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default BundleSchedulesTable
